import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Risk } from '../../_models/risk';
import { RiskSet } from '../../_models/riskSet';
import {
  AlertService,
  AuthenticationService, ClientProfileService,
  ProjectService,
} from '../../_services';
import { LogService } from '../../_services/log.service';
import { RiskService } from '../../_services/risk.service';
import { LoginHelper } from '../../helpers';
import { EditRiskComponent } from '../edit-risk/edit-risk.component';
import {MatDialog, MatDialogConfig} from "@angular/material/dialog";
import {ListMessageComponent} from "../listMessage";
import { RizkListReportComponent } from '../rizkListReport/rizkListReport.component';

@Component({
    standalone: false,
  selector: 'risk',
  templateUrl: 'risk.component.html',
  styleUrls: ['./risk.component.scss'],
  providers: [DialogService],
})
export class RiskComponent implements OnInit {
  pageTitle: string;
  collapsed: boolean = false;
  riskSets: RiskSet[];
  riskSetId: number;
  risks: Risk[];
  selectedRiskSet: RiskSet;
  groupedRisks: any;
  displayDialog: boolean = false;
  statusOrder = ['Low', 'Medium', 'High'];
  statusMap = { 'Low': 0, 'Medium': 1, 'High': 2 };
  dialogRef: DynamicDialogRef | undefined;
  rizkReportRoute: any[];

  table = {
    name: 'Risk Register',
    type: 'risk-register',
    columns: [
      {
        name: 'Date Raised',
        field: 'dateRaised',
        type: 'date',
        width: 10,
      },
      {
        name: 'Risk Description',
        field: 'riskDescription',
        type: 'string',
        width: 100,
      },
      {
        name: 'Likelihood',
        field: 'likelihood',
        type: 'select',
        width: 15,
        options: ['Low', 'Medium', 'High'],
      },
      {
        name: 'Severity',
        field: 'severity',
        type: 'select',
        width: 15,
        options: ['Low', 'Medium', 'High'],
      },
      {
        name: 'Risk',
        field: 'riskValue',
        type: 'select',
        width: 15,
        options: ['Low', 'Medium', 'High'],
      },
      {
        name: 'Type',
        field: 'type',
        type: 'select',
        width: 15,
        options: ['Inherent', 'Residual', 'Other'],
      },
      { name: 'Owner', field: 'owner', type: 'string', width: 20 },
      { name: 'Impact', field: 'impact', type: 'string', width: 20 },
      {
        name: 'Mitigation',
        field: 'mitigation',
        type: 'textarea',
        width: 50,
      },
      {
        name: 'Contingency',
        field: 'contingency',
        type: 'textarea',
        width: 50,
      },
      {
        name: 'Progress',
        field: 'progress',
        type: 'textarea',
        width: 50,
      },
      { name: 'Status', field: 'status', type: 'string', width: 10 },
      {
        name: 'Related Controls',
        field: 'relatedControls',
        type: 'cids',
        width: 100,
      },
    ],

  };

  constructor(
    public logService: LogService,
    public projectService: ProjectService,
    public router: Router,
    public route: ActivatedRoute,
    public authenticationService: AuthenticationService,
    public clientProfileService: ClientProfileService,
    public riskService: RiskService,
    public dialog: MatDialog,
    public alertService: AlertService,
    public dialogService: DialogService
  ) {
    this.clientProfileService.getPublicSettings(LoginHelper.getTenantName()).subscribe(s => this.pageTitle = s.menuLabels['RizkList'] || 'RizkLists');
  }

  ngOnInit() {
    const tenantName = LoginHelper.getTenantName();
    if (tenantName == null || LoginHelper.getUserToken() == null) {
      this.authenticationService.logout();

      return;
    }

    this.rizkReportRoute = ['/risks/rizklist-report'];

    this.loadRiskSets();
    this.route.params.subscribe((p) => {
      this.riskSetId = p['riskSet'];
      this.loadRisks(this.riskSetId);
      this.loadRiskSets();
    });
  }

  loadRiskSets() {
    this.riskService.getAllRiskSets().subscribe((r) => {
      this.riskSets = r;
      this.selectedRiskSet = this.riskSets.find(
        (t) => t.riskSetId == this.riskSetId
      );

      if (
        this.riskSets?.length > 0 &&
        !this.selectedRiskSet &&
        !this.riskSetId
      ) {
        this.selectedRiskSet = this.riskSets[0];
        this.riskSetId = this.selectedRiskSet.riskSetId;
        this.router.navigate(['/risks', this.riskSetId]);
      }
    });
  }

  loadRisks(id) {
    if (id) {
      this.riskService.getRisks(id).subscribe((r) => {
        this.risks = r;
        const div = document.createElement('div');
        this.risks.forEach((risk) => {
          div.innerHTML = risk.riskDescription || '';
          (<any>risk).riskDescriptionText = div.textContent.substring(0, 100);
        });
        this.groupedRisks = {};
        this.groupedRisks[this.table.type] = this.risks.filter(
          (s) => s.riskType == this.table.type || true
        );
        for (let k = 0; k < this.table.columns.length; k++) {
          const column = this.table.columns[k];
          if (column.type == 'cids') {
            for (let l = 0; l < r.length; l++) {
              r[l][column.field + 'List'] = r[l][column.field + 'List'] || [];
            }
          }
        }
        console.log('risks', this.risks);
      });
    }
  }

  createRiskSet() {
    this.riskService
      .addRiskSet({ name: 'Risk Set' })
      .subscribe((r) => this.router.navigate(['/risks', r]));
  }

  editRisk(risk: Risk) {
    const header = `${risk?.riskId ? 'Edit' : 'Create'} Risk${
      risk?.riskId ? ' - ' + risk?.riskId : ''
    }`;

    this.dialogRef = this.dialogService.open(EditRiskComponent, {
      width: '80%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      maximizable: true,
      data: { risk },
      header,
    });

    this.dialogRef.onClose.subscribe((risk?: Risk) => {
      console.log('close edit', risk);
      if (risk) {
        this.saveRisk(risk);
      }
    });
  }

  saveRisk(item) {
    this.groupedRisks[this.table.type] = this.risks.filter(
      (s) => s.riskType == this.table.type
    );
    for (let k = 0; k < this.table.columns.length; k++) {
      const column = this.table.columns[k];
      if (column.type == 'cids') {
        item[column.field] = (item[column.field + 'List'] || [])
          .map((c) => c.id)
          .join(';');
      }
    }

    if (item.riskId) {
      this.riskService.updateRisk(item).subscribe(() => {
        this.loadRisks(this.riskSetId);
      });
    } else {
      this.riskService.addRisk(item).subscribe(() => {
        this.loadRisks(this.riskSetId);
      });
    }
  }

  closeDialog() {
    this.displayDialog = false;
  }

  deleteRisk(risk) {
    this.riskService
      .deleteRisk(risk.riskId)
      .subscribe(() => this.loadRisks(this.riskSetId));
  }

  saveRiskSet() {
    this.riskService
      .updateRiskSet(this.selectedRiskSet)
      .subscribe(() => this.loadRiskSets());
  }

  removeRiskSet() {
    this.riskService
      .deleteRiskSet(this.selectedRiskSet.riskSetId)
      .subscribe(() => {
        this.loadRiskSets();
        this.router.navigate(['/risks']);
      });
  }

  up(item) {
    const i = this.risks.indexOf(item);
    this.risks[i] = this.risks[i - 1];
    this.risks[i - 1] = item;
    this.riskService
      .setRiskOrder(this.risks.map((p) => p.riskId))
      .subscribe(() => {
        this.loadRisks(this.riskSetId);
      });
  }

  down(item) {
    const i = this.risks.indexOf(item);
    this.risks[i] = this.risks[i + 1];
    this.risks[i + 1] = item;
    this.riskService
      .setRiskOrder(this.risks.map((p) => p.riskId))
      .subscribe(() => {
        this.loadRisks(this.riskSetId);
      });
  }

  saveOrder(e) {
    this.riskService
      .setRiskOrder(this.risks.map((p) => p.riskId))
      .subscribe(() => {
        this.loadRisks(this.riskSetId);
      });
  }

  selectChanged(item, field) {
    if (field == 'likelihood' || field == 'severity') {
      item.riskValue =
        this.statusOrder[
          Math.max(
            this.statusMap[item.likelihood || 'Low'],
            this.statusMap[item.severity || 'Low']
          )
        ];
    }
  }

  onRiskSetChanged(event) {
    if (this.selectedRiskSet) {
      this.router.navigate(['/risks', this.selectedRiskSet.riskSetId]);
    } else {
      this.router.navigate(['/risks']);
    }
  }

  toggleItems() {
    const opened = document.querySelectorAll(".pi-chevron-down");
    const closed = document.querySelectorAll(".pi-chevron-right");
    if (closed.length == 0) {
      Array.from(opened).forEach(i => (i as any).click());
    } else {
      Array.from(closed).forEach(i => (i as any).click());
    }
  }

  importRisks(event) {
    this.alertService.clear();

    let attachments = event.target.files;
    if (attachments.length > 0) {
      let file: File = attachments[0];
      this.riskService.import(file, this.riskSetId).subscribe(
        (res) => {
          let config: MatDialogConfig = {
            panelClass: 'custom-overlay-pane-class',
            width: 'auto',
            height: '90%',
            data: {
              items: res,

              title: "Import report"
            }
          };
          this.loadRisks(this.riskSetId);
          this.dialog.open(ListMessageComponent, config);
          this.ngOnInit();
        },
        (error) => {
          const errorMessage = 'An error occurred while upload control items.';
          this.alertService.error(errorMessage);
        });
    }
  }

  addToken(html) {
    return html
      ? html.replace(
          /api\/attachments\/file\?/gi,
          'api/attachments/file?token=' +
            LoginHelper.getFileToken() +
            '&'
        )
      : html;
  }

  openRizkListReport() {
    const config: MatDialogConfig = {
      width: '90%',
      height: '85%',
      panelClass: 'custom-overlay-pane-class',
      data: {
        title: 'Internal Assessment View',
      }
    };

    this.dialog.open(RizkListReportComponent, config);
  }


}
